(function () {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'open') continue;

      const details = mutation.target;
      if (details.tagName !== 'DETAILS' || !details.hasAttribute('open')) continue;

      const accordion = details.closest('accordion-custom');
      if (!accordion) continue;

      const parent = accordion.parentElement;
      if (!parent) continue;

      const siblings = parent.querySelectorAll(':scope > accordion-custom');
      siblings.forEach((sibling) => {
        if (sibling === accordion) return;
        const siblingDetails = sibling.querySelector('details');
        if (!siblingDetails || !siblingDetails.hasAttribute('open')) return;

        const siblingSummary = sibling.querySelector('summary');
        if (siblingSummary) siblingSummary.click();
      });
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });
})();

/**
 * Fix: Product Grid Carousel — Fraction total count correction
 * global.js uses this.items.length (raw DOM children) which may differ
 * from Swiper's actual slide count. We watch each .custom-fraction element
 * and correct the total using the Swiper instance stored on the .swiper element.
 * 2026-05-266
 */
(function () {
  function attachFractionObserver(fractionEl) {
    if (fractionEl._d2nObserverAttached) return;
    fractionEl._d2nObserverAttached = true;

    const swiperEl = fractionEl.closest('.swiper-component-product-grid')?.querySelector('.swiper');
    if (!swiperEl) return;

    const fractionObserver = new MutationObserver(() => {
      const swiperInstance = swiperEl.swiper;
      if (!swiperInstance || !swiperInstance.slides) return;

      const correctTotal = swiperInstance.slides.length;
      const totalSpan = fractionEl.querySelector('.swiper-pagination-total');
      if (totalSpan && parseInt(totalSpan.textContent) !== correctTotal) {
        totalSpan.textContent = correctTotal;
      }
    });

    fractionObserver.observe(fractionEl, { childList: true, subtree: true });
  }

  // Attach to any fraction elements already in the DOM
  function init() {
    document.querySelectorAll('.swiper-component-product-grid .custom-fraction').forEach(attachFractionObserver);
  }

  // Also watch for dynamically added fraction elements (e.g. deferred Swiper init)
  const domObserver = new MutationObserver(() => {
    document.querySelectorAll('.swiper-component-product-grid .custom-fraction').forEach(attachFractionObserver);
  });

  domObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Sync color scheme of the main collection product grid wrapper to #MainContent and its parent
 */
(function () {
  console.log("custom.js color-scheme sync module loaded.");

  function syncMainContentColorScheme() {
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      console.warn("syncMainContentColorScheme: #MainContent not found in DOM.");
      return;
    }

    // Find the collection wrapper or any element inside #MainContent with a color scheme class
    const colorElement = document.querySelector('#MainContent .template-collection') || 
                        document.querySelector('#MainContent [class*="color-scheme-"]');
    if (!colorElement) {
      console.log("syncMainContentColorScheme: No color scheme element found inside #MainContent.");
      // Clean up residual color classes from MainContent and its parent
      for (const className of Array.from(mainContent.classList)) {
        if (className.startsWith('color-') || className === 'gradient') {
          mainContent.classList.remove(className);
        }
      }
      if (mainContent.parentElement) {
        for (const className of Array.from(mainContent.parentElement.classList)) {
          if (className.startsWith('color-') || className === 'gradient') {
            mainContent.parentElement.classList.remove(className);
          }
        }
      }
      return;
    }

    // Find the color class starting with 'color-scheme-' or 'color-' on the element
    let colorClass = null;
    for (const className of colorElement.classList) {
      if (className.startsWith('color-scheme-') || className.startsWith('color-')) {
        colorClass = className;
        break;
      }
    }

    if (!colorClass) {
      console.log("syncMainContentColorScheme: Found color element but no color- class was matching.");
      return;
    }

    const hasGradient = colorElement.classList.contains('gradient');
    const mainHasColor = mainContent.classList.contains(colorClass);
    const mainHasGradient = mainContent.classList.contains('gradient');

    // Sync classes to #MainContent and its parent element
    if (!mainHasColor || (hasGradient !== mainHasGradient)) {
      // Remove any existing color-* and gradient classes from MainContent
      for (const className of Array.from(mainContent.classList)) {
        if (className.startsWith('color-') || className === 'gradient') {
          mainContent.classList.remove(className);
        }
      }
      // Apply new classes to #MainContent
      mainContent.classList.add(colorClass);
      if (hasGradient) {
        mainContent.classList.add('gradient');
      }

      // Apply new classes to the parent of #MainContent (e.g. body or wrapper div)
      if (mainContent.parentElement) {
        for (const className of Array.from(mainContent.parentElement.classList)) {
          if (className.startsWith('color-') || className === 'gradient') {
            mainContent.parentElement.classList.remove(className);
          }
        }
        mainContent.parentElement.classList.add(colorClass);
        if (hasGradient) {
          mainContent.parentElement.classList.add('gradient');
        }
      }

      console.log(`syncMainContentColorScheme: Copied "${colorClass}" and gradient to #MainContent and its parent.`);
    }
  }

  // Expose as global function for manual console execution/testing
  window.syncMainContentColorScheme = syncMainContentColorScheme;

  // Run immediately and on page load
  syncMainContentColorScheme();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMainContentColorScheme);
  }

  // Run when sections are dynamically loaded/updated in the theme customizer
  document.addEventListener('shopify:section:load', syncMainContentColorScheme);

  // Fallback interval to ensure it works instantly in the Customizer and dynamic pages
  setInterval(syncMainContentColorScheme, 250);
})();

/**
 * Customize mobile menu: replace space links and style phone link
 */
(function () {
  function customizeMobileMenu() {
    // 1. Convert "space" items to dividers
    const listItems = document.querySelectorAll('.menu-drawer__list-item');
    listItems.forEach((item) => {
      const link = item.querySelector('a');
      if (link && link.textContent.trim().toLowerCase() === 'space') {
        item.classList.add('menu-drawer__list-item--divider');
        link.remove();
      }
    });

    // 2. Convert phone link to a bottom button
    const phoneLink = document.querySelector('.menu-drawer a[href^="tel:"]');
    if (phoneLink) {
      const parentItem = phoneLink.closest('.menu-drawer__list-item');
      if (parentItem) {
        parentItem.classList.add('menu-drawer__list-item--phone');
        phoneLink.className = 'menu-drawer__phone-button';
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', customizeMobileMenu);
  } else {
    customizeMobileMenu();
  }

  // Run when section loads in customizer
  document.addEventListener('shopify:section:load', customizeMobileMenu);

  // Watch for DOM changes (in case drawer content is dynamically inserted or modified)
  const observer = new MutationObserver(customizeMobileMenu);
  observer.observe(document.body, { childList: true, subtree: true });
})();



/* Smooth Scrolling */
document.querySelectorAll('.scroll-link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));

    const offset = window.innerWidth <= 768 ? 30 : 100;

    const position = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  });
});



/** Inline linking with offst */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');

      if (!targetId || targetId === '#') return;

      const target = document.querySelector(targetId);

      if (!target) return;

      e.preventDefault();

      const offset = 120;
      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      history.pushState(null, '', targetId);
    });
  });
});